import API from "../Common/Endpoint/serviceConstrants";
import axiosInstanceClient from '../Common/Axios/axiosInstanceClient';

export const callAddToCartPostApi = async (payload) => {
  const { data = [] } = await axiosInstanceClient.post(API.addToCart, payload);
  return data;
};